<template>
    <tr
        ref="tableTr"
        :class="[
            `tr-table-state-${state}`,
            {'is-selected':isSelected,
             'selected': data,
             'is-expand': maxHeight !== '0px',
             'activeEdit': activeEdit,
             'hoverFlat': $parent.hoverFlat
            }
        ]"
        class="tr-values vs-table--tr"
        @click="clicktr"
        @dblclick="dblclicktr"
    >
        <td
            v-if="$parent.multiple || $slots.expand"
            :class="{'active-expanded': expanded}"
            class="td-check"
        >
            <vs-checkbox
                v-if="$parent.multiple"
                :checked="isSelected"
                color="secondary"
                size="small"
                @change="handleCheckbox"
            />

            <vs-icon v-if="$slots.expand">
                keyboard_arrow_down
            </vs-icon>
        </td>
        <slot />
    </tr>
</template>
<script>
import Vue from 'vue';
import trExpand from './VxTrExpand.vue';

export default {
    name:  'VxTr',
    props: {
        data: {
            default: null,
        },
        state: {
            default: null,
            type:    String,
        },
    },
    data: () => ({
        colspan:    0,
        expanded:   false,
        maxHeight:  '0px',
        activeEdit: false,
    }),
    computed: {
        getColspanExpand() {
            const lengthx = this.$parent.$refs.colgroup.querySelectorAll('th').length;

            return lengthx;
        },
        isSelected() {
            if (this.$parent.multiple && this.$parent.value) {
                return this.data ? this.$parent.value.includes(this.data) : false;
            }

            return this.data ? this.$parent.value === this.data : false;
        },
        styleExpand() {
            return {
                maxHeight: this.maxHeight,
            };
        },
    },
    watch: {
        '$parent.datax': function () {
            this.collapseExpandedData();
        },
    },
    created() {
        if (this.$slots.expand) this.$parent.hasExpadableData = true;
    },
    mounted() {
        this.$nextTick(() => {
            this.colspan = this.$parent.$refs.thead.querySelectorAll('th').length;

            if (this.$slots.expand) {
                this.colspan++;
            }
        });
    },
    methods: {
        clicktd(evt) {
            if (this.$parent.multiple || !this.$slots.expand) return;

            const tr = evt.target.closest('tr');

            if (this.expanded) {
                tr.parentNode.removeChild(tr.nextSibling);
                tr.classList.remove('tr-expandedx');
                this.expanded = false;
            } else {
                tr.classList.add('tr-expandedx');
                const Trx = Vue.extend(trExpand);
                const instance = new Trx();
                instance.$props.colspan = this.colspan;
                instance.$slots.default = this.$slots.expand;
                instance.vm = instance.$mount();
                const newTR = document.createElement('tr').appendChild(instance.vm.$el);
                this.insertAfter(tr, newTR);
                this.expanded = true;
            }
        },
        clicktr(evt) {
            this.$parent.clicktr(this.data, true);

            if (this.$slots.expand) {
                this.clicktd(evt);
            }
        },
        collapseExpandedData() {
            if (this.expanded) {
                const tr = this.$refs.tableTr;
                tr.parentNode.removeChild(tr.nextSibling);
                tr.classList.remove('tr-expandedx');
                this.expanded = false;
            }
        },
        handleCheckbox() {
            this.$parent.handleCheckbox(this.data);
        },
        dblclicktr() {
            this.$parent.dblclicktr(this.data, true);
        },
        insertAfter(e, i) {
            if (e.nextSibling) {
                e.parentNode.insertBefore(i, e.nextSibling);
            } else {
                e.parentNode.appendChild(i);
            }
        },
    },
};
</script>
